import { useState } from "react";
import CSS from "./styles.module.css";
import { useEffect } from "react";
import { useRef } from "react";

const Switch = ({ checked, id, name, onChange, onClick }) => {
	const [isActive, setisActive] = useState(false);
	const switchRef = useRef(null);

	useEffect(() => {
		if (checked) {
			setisActive(true);
			switchRef.current.checked = true;
		} else {
			setisActive(false);
			switchRef.current.checked = false;
		}
	}, [checked]);

	const handleCheck = () => {
		if (checked) {
			setisActive(true);
		} else if (checked === false) {
			setisActive(false);
		}
	};

	return (
		<div
			className={`${CSS.Switch} ${isActive ? CSS.SwitchActive : ""}`}
			onClick={onClick}
		>
			<div className={CSS.Dial} />
			<input
				type="checkbox"
				checked={isActive}
				name={name}
				id={id}
				ref={switchRef}
			/>
		</div>
	);
};

export default Switch;
